import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges, HostListener, ElementRef
} from '@angular/core';
import { Dialog } from './luci-dialog.model';
import { CommonUtils } from '../commons/utils/common.utils';


@Component({
  selector: 'luci-dialog',
  templateUrl: './luci-dialog.component.html',
  styleUrls: ['./luci-dialog.component.scss']
})
export class LuciDialogComponent implements OnInit, OnChanges {
  @Input() isOpen = false;
  @Input() dialog: Dialog = {
    id: '',
    headline: '',
    message: '',
  };
  @Input() isExtTemplate = false;
  @Input() isFooter = false;
  @Input() smallHeadline = true;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Input() cancelLabel = '';
  @Input() ActionLabel = '';
  @Input() isActionDisabled = false;
  @Input() isCloseTemplate = false;
  @Input() isCancelActionDisabled = false;
  @Input() isBackDrop = true;
  @Input() isNonModal = false;

  dragging: HTMLElement;

  @HostListener('document:mousemove', ['$event'])
  mouseMove(event) {
    if (this.dragging) {
      console.log(this.dragging.offsetTop, event.pageX, event.pageY, event);
     // this.el.nativeElement.offsetTop =  event.pageY;
    //  this.el.nativeElement.offsetLeft =  event.pageX;
    }
  }

  @HostListener('document:mousedown', ['$event'])
  mousedown(event) {
    // if (event.target.className.includes('luci-dialog') && this.isNonModal) {
    //   this.dragging = event.target;
    // } else {
    //   this.dragging = null;
    // }
  }

  @HostListener('document:mouseup', ['$event'])
  mouseup(event) {
     this.dragging = null;
  }

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  resolveDialog() {
    // this.isOpen = false;
    this.close.emit(true);
  }

  cancelDialog() {
    if (!this.isCloseTemplate) {
      this.isOpen = false;
    }
    CommonUtils.removeClass(document.body, 'no-scroll');
    this.close.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isOpen) {
      if (changes.isOpen.currentValue) {
        CommonUtils.addClass(document.body, 'no-scroll');
      } else {
        CommonUtils.removeClass(document.body, 'no-scroll');
      }
    }
  }


}
